module.exports = __webpack_public_path__ + "static/media/StepguideSpiderStep1.1f3d2dc4.png";